import { LabelTag } from "@/molecules/LabelTag"

import type { Label } from "@/domain/label"

export const LabelCell = (_: unknown, record: Label) => (
  <LabelTag name={record.name} color={record.color} />
)
